/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_P1Inputs */

const en_guide_json_schema_s4_p1 = /** @type {(inputs: Guide_Json_Schema_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema is used across the development stack for data validation:`)
};

const ko_guide_json_schema_s4_p1 = /** @type {(inputs: Guide_Json_Schema_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schema는 개발 스택 전반에서 데이터 유효성 검사에 사용됩니다:`)
};

const ja_guide_json_schema_s4_p1 = /** @type {(inputs: Guide_Json_Schema_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Schemaは開発スタック全体でデータ検証に使用されています：`)
};

/**
* | output |
* | --- |
* | "JSON Schema is used across the development stack for data validation:" |
*
* @param {Guide_Json_Schema_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_p1 = /** @type {((inputs?: Guide_Json_Schema_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_p1(inputs)
	return ja_guide_json_schema_s4_p1(inputs)
});